import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import { CSSProperties } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { Colors } from '@shared/styles';

type InitialsAvatarSize = 'large' | 'normal' | 'small' | 'tiny';

export interface InitialsAvatarProps {
  name: string;
  id: number;
  size?: InitialsAvatarSize;
  /** Without `className` or `style`, the avatar fills its parent. */
  className?: ClassValue;
  style?: CSSProperties;
}

export function InitialsAvatar({
  name,
  id,
  size = 'normal',
  className,
  style,
}: InitialsAvatarProps) {
  const fill = isNil(className) && isNil(style);

  return (
    <View
      center
      fill={fill}
      className={className}
      style={{ backgroundColor: getAvatarBackgroundColor(id), ...style }}
    >
      <Text weight="bold" style={getPlaceholderTextStyle(size)}>
        {toInitials(name)}
      </Text>
    </View>
  );
}
function getAvatarBackgroundColor(id: number): string {
  return Colors.v2.avatar.user[id % Colors.v2.avatar.user.length];
}

function getPlaceholderTextStyle(size: InitialsAvatarSize): CSSProperties | undefined {
  if (size === 'tiny') {
    return { fontSize: 7 };
  }
  if (size === 'small') {
    return { fontSize: 10 };
  }
  if (size === 'large') {
    return { fontSize: 28 };
  }
  return undefined;
}

function toInitials(name: string): string {
  // https://stackoverflow.com/a/8279881/9117995
  const match = name.match(/\b(\w)/g);
  if (!match) {
    return '';
  }
  return match.join('').slice(0, 2).toUpperCase();
}
